<template>
  <div class="loader__wrapper" :class="wrapperCssClass">
    <div class="loader-cubics__text">
      <slot name="text"></slot>
    </div>
    <div class="loader-cubics">
      <template v-for="n in 9">
        <div :key="n" class="loader-cubics__box" :class="getColor()" />
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    wrapperCssClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    getColor() {
      return ['-green', '-red', '-blue'][Math.floor(Math.random() * 3)];
    }
  }
};
</script>
<style src="./loader.css" />
<style lang="scss" src="./loader-cubics.scss" />
